// extracted by css-extract-rspack-plugin
export default {"tabbedNav":"TabbedTimeline-module__tabbedNav__rAS36"};